@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Iowa</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }

      <!-- UM Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }
      <!-- StateMinimum_VaryBetweenStates -->
      @if (
        baseRules["selectionId"] === "StateMinimum_VaryBetweenStates" ||
        baseRules["selectionId"] === "IndividualState_CombinedSingleLimit" ||
        baseRules["selectionId"] === "IndividualState_Split" ||
        baseRules["selectionId"] === "IndividualState_VaryBetweenStates"
      ) {
        <h3 class="axis-h5">UM Coverage:</h3>
      }

      <!-- levelOneUM_Radio - Uninsured Motorists Coverage Selection -->
      @if (controls?.length >= 13) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[12].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[12].formControlName)?.touched &&
              reactiveForm.get(controls[12].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[12].formControlName }}">
            @for (control of controls[12].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[12].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[12].formControlName)?.touched) {
            @if (reactiveForm.get(controls[12].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }
      <!-- UM Radio level two -->
      @if (controls?.length >= 10) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[10].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[10].formControlName)?.touched &&
              reactiveForm.get(controls[10].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[10].formControlName }}">
            @for (control of controls[10].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[10].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[10].formControlName)?.touched) {
            @if (reactiveForm.get(controls[10].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }
      <!-- Displaying minimum limit as readonly text for UM -->
      <div class="axis-grid">
        @if (
          (baseRules?.["UM_SplitMinLimits_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
            reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[4].label }} </label>
              <div id="um_splitminlimits_20k_40k-pdffield-iowa">{{ controls[4].data[0].name }}</div>
            </div>
          </div>
        }
        @if (
          (baseRules?.["UM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
            reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[5].label }} </label>
              <div id="um_combinedsingleminlimit_40k-pdffield-iowa">{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        }
      </div>

      <!-- UM Limits Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 2 : 6; track $index) {
          @if (
            baseRules[control.baseRuleKey]?.includes("show") &&
            (reactiveForm.get('levelOneUM_Radio')?.value === 'Limits_LevelOneUM_Radio' ||
              reactiveForm.get('levelOneUM_Radio')?.value?.value === 'Limits_LevelOneUM_Radio')
          ) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  (onSelect)="changeOnSelection($event, control.formControlName)"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.
                    </span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- UIM Radio level two -->
      @if (
        baseRules["selectionId"] === "StateMinimum_VaryBetweenStates" ||
        baseRules["selectionId"] === "IndividualState_CombinedSingleLimit" ||
        baseRules["selectionId"] === "IndividualState_Split" ||
        baseRules["selectionId"] === "IndividualState_VaryBetweenStates"
      ) {
        <h3 class="axis-h5">UIM Coverage:</h3>
      }

      <!-- levelOneUIM_Radio - Underinsured Motorists Coverage Selection -->
      @if (controls?.length >= 14) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[13].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[13].formControlName)?.touched &&
              reactiveForm.get(controls[13].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[13].formControlName }}">
            @for (control of controls[13].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[13].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[13].formControlName)?.touched) {
            @if (reactiveForm.get(controls[13].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }
      @if (controls?.length >= 11) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[11].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[11].formControlName)?.touched &&
              reactiveForm.get(controls[11].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[11].formControlName }}">
            @for (control of controls[11].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[11].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[11].formControlName)?.touched) {
            @if (reactiveForm.get(controls[11].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
              >
                Please select an option.
              </span>
            }
          }
        </div>
      }
      <!-- Displaying minimum limit as readonly text for UIM -->
      <div class="axis-grid">
        @if (
          (baseRules?.["UIM_SplitMinLimits_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
            reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[8].label }} </label>
              <div id="uim_splitminlimits_20k_40k-pdffield-iowa">{{ controls[8].data[0].name }}</div>
            </div>
          </div>
        }
        @if (
          (baseRules?.["UIM_CombinedSingleMinLimit_DropDown"] || "").includes("readonly") &&
          (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
            reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
        ) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[9].label }} </label>
              <div id="uim_combinedsingleminlimit_40k-pdffield-iowa">{{ controls[9].data[0].name }}</div>
            </div>
          </div>
        }
      </div>

      <!-- UIM Limits Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 6 : 10; track $index) {
          @if (
            baseRules[control.baseRuleKey]?.includes("show") &&
            (reactiveForm.get('levelOneUIM_Radio')?.value === 'Limits_LevelOneUIM_Radio' ||
              reactiveForm.get('levelOneUIM_Radio')?.value?.value === 'Limits_LevelOneUIM_Radio')
          ) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  (onSelect)="changeOnSelection($event, control.formControlName)"
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.
                    </span>
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      <!-- Display message when both radio buttons are checked -->
      @if (
        baseRules["selectionId"] === "StateMinimum_VaryBetweenStates" ||
        baseRules["selectionId"] === "IndividualState_VaryBetweenStates"
      ) {
        @if (bothRadioButtonsChecked) {
          <div
            class="axis-alert axis-alert-info"
            style="padding: 0.75rem"
          >
            <b>{{ textValues?.Same_Limit_Message }}</b>
          </div>
        }
      }

      <!-- Display Refer Text -->
      <p>{{ textValues?.Refer_Text }}</p>
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Iowa</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOne_UM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UM }}
      </label>
    </div>
  }

  @if (baseRules?.Reject_LevelOne_UIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UIM }}
      </label>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-4">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
}